export const config = {
  asset: {
    root: `${process.env.STATIC_ASSET_ROOT_URL_PATH}`
  },
  inventory: `${process.env.INVENTORY_ROOT_URL_PATH}`,
  cdn: {
    // ! root: 'https://static.marketreach.io/EBY'
    root: `${process.env.STATIC_ASSET_ROOT_URL_PATH}`
  }
}